export default "/assets/3dbcad7ca0fe41ec.svg"